(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dream-unwind-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  const activeAnimations = new Set();
  const depthTargets = new Set();
  const carousels = new Map();
  let frame = 0;
  const allowed = () => !media.matches && document.body.dataset.duMotion === 'true' && !window.Shopify?.designMode;
  const animate = (element, frames, options) => {
    if (!element.animate || !allowed()) return;
    const animation = element.animate(frames, options);
    activeAnimations.add(animation);
    animation.finished.catch(() => {}).finally(() => activeAnimations.delete(animation));
  };
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      revealObserver.unobserve(entry.target);
      animate(entry.target, [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 750, delay: Number(entry.target.dataset.duDelay || 0), easing: 'cubic-bezier(.22,.68,.2,1)' });
    });
  }, { threshold: 0.08 }) : null;
  const observe = root => {
    const selectors = '.du-section [class*="__header-"], .du-pain [class*="__grid-"] > div, .du-products [class*="__product-card-"], .du-sleep [class*="-text-content-"], .du-sleep [class*="-image-wrapper-"], .du-sleep [class*="-callouts-"], .du-evening [class*="__stage-content-"], .du-newsletter [class*="-content-inner-"]';
    root.querySelectorAll(selectors).forEach((element, index) => {
      if (element.dataset.duObserved || !revealObserver) return;
      element.dataset.duObserved = 'true';
      element.dataset.duDelay = String(index % 4 * 45);
      revealObserver.observe(element);
    });
    root.querySelectorAll('[data-du-hero]').forEach(hero => {
      if (hero.dataset.duInit) return;
      hero.dataset.duInit = 'true';
      depthTargets.add(hero);
      const copy = hero.querySelector('.du-hero-copy');
      if (copy) Array.from(copy.children).forEach((item, index) => animate(item, [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 900, delay: index * 100, easing: 'cubic-bezier(.22,.68,.2,1)' }));
      const picture = hero.querySelector('picture');
      if (picture) animate(picture, [{ transform: 'scale(1.07)' }, { transform: 'scale(1)' }], { duration: 2000, easing: 'cubic-bezier(.2,.65,.2,1)' });
    });
    root.querySelectorAll('.du-products').forEach(section => {
      if (carousels.has(section)) return;
      const track = section.querySelector('[data-du-track]');
      const controls = section.querySelector('[data-du-controls]');
      if (!track || !controls) return;
      const previous = controls.querySelector('[data-du-prev]');
      const next = controls.querySelector('[data-du-next]');
      const meter = controls.querySelector('.du-track-meter');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 4;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        meter.style.setProperty('--du-track-progress', String(Math.min(1, (track.scrollLeft + track.clientWidth) / Math.max(track.scrollWidth, 1))));
      };
      const move = direction => {
        const card = track.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0') : track.clientWidth;
        track.scrollBy({ left: direction * step, behavior: media.matches ? 'auto' : 'smooth' });
      };
      const abort = new AbortController();
      previous.addEventListener('click', () => move(-1), { signal: abort.signal });
      next.addEventListener('click', () => move(1), { signal: abort.signal });
      track.addEventListener('scroll', update, { passive: true, signal: abort.signal });
      const resize = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
      if (resize) resize.observe(track);
      carousels.set(section, { resize, abort });
      update();
    });
    scheduleDepth();
  };
  const updateDepth = () => {
    frame = 0;
    depthTargets.forEach(hero => {
      if (!hero.isConnected) { depthTargets.delete(hero); return; }
      const image = hero.querySelector('.du-hero-media');
      if (!image) return;
      if (!allowed() || !fine.matches || document.body.dataset.duParallax !== 'true') { image.style.transform = ''; return; }
      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      image.style.transform = `translate3d(0,${progress * 46}px,0) scale(${1.02 + progress * .035})`;
    });
  };
  function scheduleDepth() { if (!frame) frame = requestAnimationFrame(updateDepth); }
  const start = () => observe(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', event => observe(event.target));
  document.addEventListener('shopify:section:unload', event => {
    carousels.forEach((controller, section) => {
      if (!event.target.contains(section)) return;
      controller.abort.abort();
      controller.resize?.disconnect();
      carousels.delete(section);
    });
    event.target.querySelectorAll('[data-du-observed]').forEach(element => revealObserver?.unobserve(element));
    event.target.querySelectorAll('[data-du-hero]').forEach(element => depthTargets.delete(element));
  });
  window.addEventListener('scroll', scheduleDepth, { passive: true });
  window.addEventListener('resize', scheduleDepth, { passive: true });
  media.addEventListener('change', () => { if (media.matches) activeAnimations.forEach(animation => animation.cancel()); scheduleDepth(); });
  fine.addEventListener('change', scheduleDepth);
})();
  } catch(e) { console.error(e); }
})();

})();
